<template>
  <div id="ultra-frame" :style="`background-color:${bg}`">
    <div id="ultra-container">
      <div style="display:flex">

        <!-- LABEL -->
        <div>
          <FillableCell
            v-for="row in rows"
            :key="`${row.type}-${row.name}-label`"
            :height="32"
            :width="128"
            flex_align_horizontal="flex-end"
          >
            <template #content>
              <TText
                :text="row.name"
                :size="12"
                :font_weight="400"
                :color="fg"
              />
            </template>
          </FillableCell>
        </div>

        <!-- RADIO BUTTONS -->
        <div>
          <RadioKnobRow
            v-for="row in rows"
            :key="`${row.type}-${row.name}-row`"
            :knobs="row.functions"
            :selected_id="row.selected_id"
            :cell_count="4"
            :is_disabled="!row.active"
            :height="32"
            :width="64"
            @knobClicked="knobClicked(row, $event)"
          />
        </div>

        <!-- ACTIVE TOGGLE -->
        <div>
          <FillableCell
            v-for="row in rows"
            :key="`${row.type}-${row.name}-active`"
            :height="32"
            :width="64"
            flex_align_horizontal="flex-start"
          >
            <template #content>
              <ToggleCapsule
                :is_active="row.active"
                :background_color="bg"
                :foreground_color="fg"
                @toggleClicked="row.active = !row.active"
              />
            </template>
          </FillableCell>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadioKnobRow from '@/modules/WorkPackageWIP/RadioKnobRow.module.vue';
import FillableCell from '@/components/WorkPackageWIP/FillableCell.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import ToggleCapsule from '@/components/WorkPackageWIP/ToggleCapsule.component.vue';

  export default {
    components: {
      RadioKnobRow,
      FillableCell,
      TText,
      ToggleCapsule,
    },

    props: [

    ],

    data: () => ({
      bg: '#FFC900',
      fg: '#000',
      // bg: '#330011',
      // fg: '#FFF',

      rows: [
        {
          name: 'Platzhaler',
          type: 'workpackage',
          functions: [
            { level: 1, id: 2 },
            { level: 2, id: 5 },
            { level: 4, id: 6 }
          ],
          selected_id: -1,
          active: true,
        },
        {
          name: 'Placeholder',
          type: 'workpackage',
          functions: [
            { level: 1, id: 12 },
            { level: 2, id: 15 },
            { level: 3, id: 16 },
            { level: 4, id: 17 }
          ],
          selected_id: -1,
          active: true,
        },
        {
          name: 'Einwort',
          type: 'workpackage',
          functions: [
            { level: 3, id: 26 },
            { level: 4, id: 27 }
          ],
          selected_id: -1,
          active: true,
        },
        {
          name: 'Sinnfrei',
          type: 'workpackage',
          functions: [
            { level: 1, id: 32 },
            { level: 4, id: 37 }
          ],
          selected_id: -1,
          active: true,
        },
        {
          name: 'Ganzwichtig',
          type: 'workpackage',
          functions: [
            { level: 3, id: 42 },
          ],
          selected_id: -1,
          active: true,
        },
      ],
    }),

    methods: {
      // TODO: this needs to mutate the in use level
      knobClicked(row, selected_id) {
        row.selected_id = selected_id;
      },
    },
  }
</script>

<style>

</style>
